import api from './api';

export const uploadManualCartImage = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await api.post('/upload/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
};

export const deleteUploadedImage = async (fileId) => {
  const response = await api.delete(`/upload/${fileId}/delete/`);
  return response.data;
};

export const addManualCartItem = async ({
  cartItem,
  userIdentifier,
  isProductRequestItem = false,
  productRequestNumber = '',
  productRequestItemId = '',
}) => {
  const response = await api.post('/admin/cart/manual-add/', {
    cartItem,
    user_identifier: userIdentifier,
    is_product_request_item: isProductRequestItem,
    product_request_number: productRequestNumber,
    product_request_item_id: productRequestItemId || undefined,
  });

  return response.data;
};


